"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.estimateDays = estimateDays;
exports.calculateRawMeanDifference = calculateRawMeanDifference;
exports.estimateSampleSize = estimateSampleSize;

// Estimates the number of days and experiment should run
function estimateDays(requiredSamples, activeUsers, samplingRate) {
  const days = requiredSamples / (activeUsers * samplingRate);
  let durationDays = Math.round(days) + 3; // Minumum running days must be 7

  if (durationDays < 7) {
    durationDays = 7;
  }

  return durationDays;
} // Calculate raw mean difference


function calculateRawMeanDifference(mean, mde) {
  const rawMeanDiff = mean * mde;
  return rawMeanDiff.toPrecision(3);
} // Estimate the sample size


function estimateSampleSize(sigma, za, rawMeanDifference) {
  const estimatedTraffic = 2 * ((za + 0.84) * (sigma / rawMeanDifference)) ** 2;
  let sampleSize = Number(estimatedTraffic.toPrecision(2)); // Minimum traffic must be 1000

  if (sampleSize < 1000) {
    sampleSize = 1000;
  }

  return sampleSize;
}